import { render } from "./CategoryElevenDuplicateDialog.vue?vue&type=template&id=09c683d4&scoped=true"
import script from "./CategoryElevenDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryElevenDuplicateDialog.vue?vue&type=script&lang=ts"

import "./CategoryElevenDuplicateDialog.vue?vue&type=style&index=0&id=09c683d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09c683d4"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
